import { render, staticRenderFns } from "./SntProductTable.vue?vue&type=template&id=649fbcfa&scoped=true&"
import script from "./SntProductTable.vue?vue&type=script&lang=js&"
export * from "./SntProductTable.vue?vue&type=script&lang=js&"
import style0 from "./SntProductTable.vue?vue&type=style&index=0&id=649fbcfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649fbcfa",
  null
  
)

export default component.exports